import { Country, ICountry } from '../country';
import {
  ICalendarHoliday,
  ICalendarHolidayData,
  ICalendarHolidayFieldError,
  ICalendarHolidayFieldErrorData,
  ITimeOffCalendar,
  ITimeOffCalendarData
} from './timeoff-calendar.types';

export class TimeOffCalendar implements ITimeOffCalendar {
  readonly id?: number;
  readonly name?: string;
  readonly country?: ICountry;

  constructor(data?: ITimeOffCalendarData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }
      if (data.name) {
        this.name = data.name;
      }
      if (data.country) {
        this.country = new Country(data.country);
      }
    }
  }

  toString(): string {
    let stringRepresentation = this.name ?? '';
    if (this.country) {
      stringRepresentation += ` (${this.country.code})`;
    }
    return stringRepresentation.trim();
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class CalendarHoliday implements ICalendarHoliday {
  readonly id?: number;
  readonly name: string;
  readonly date: string;
  readonly is_paid?: boolean;
  readonly calendar: ITimeOffCalendar | number;

  constructor(data: ICalendarHolidayData) {
    if (data.id) {
      this.id = data.id;
    }

    this.name = data.name ?? '';

    this.date = data.date ?? '';

    this.is_paid = data.is_paid ?? false;

    if (typeof data.calendar == 'number') {
      this.calendar = data.calendar;
    } else {
      this.calendar = new TimeOffCalendar(data.calendar);
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class CalendarHolidayFieldError implements ICalendarHolidayFieldError {
  readonly name: string[] = [];
  readonly date?: string[] = [];
  readonly is_paid?: string[] = [];
  readonly country?: string[] = [];

  constructor(data?: ICalendarHolidayFieldErrorData) {
    if (data) {
      if (data.name) {
        this.name = data.name;
      }

      if (data.date) {
        this.date = data.date;
      }

      if (data.is_paid) {
        this.is_paid = data.is_paid;
      }

      if (data.country) {
        this.country = data.country;
      }
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
    this.date!.splice(0, this.date!.length);
    this.is_paid!.splice(0, this.is_paid!.length);
    this.country!.splice(0, this.country!.length);
  }

  static isCalendarHolidayFieldError(
    data: ICalendarHolidayFieldErrorData
  ): boolean {
    if (data.name && Array.isArray(data.name)) {
      return true;
    } else if (data.date && Array.isArray(data.date)) {
      return true;
    } else if (data.is_paid && Array.isArray(data.is_paid)) {
      return true;
    } else if (data.country && Array.isArray(data.country)) {
      return true;
    }
    return false;
  }
}
